module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_02@3x-35da0a1373b8554d01b93edf8f71d3b7.webp";